import { grey } from "@mui/material/colors";
export var PDIKeys = {
    paging: "PDIPaging",
    technicianInspector: "technicianInspectorName",
    searchByVinEngine: "searchByEngine&Vinno",
    GetGroupKeys: 'getGroupKeys',
    GetInspectionData: 'getInspectionData',
    GetRowData: 'getRowData',
    CreatePdi: "CreatePdiCheck",
    attachmentCreate: "attachmentCreatepdi",
    attachmentCreatewithPayload: "attachmentCreatepdipayload",
    attachmentSchemaName: "PreDeliveryCheckAttachment",
    systemName: "PreDeliveryCheck",
    pdiCheckGet: "pdiCheckGet",
    pdiCheckUpdate: "pdiCheckUpdate",
    QuestionGroupSystemName: 'PDICheck',
    checkVinnoCreated: "checkVinnoCreated",
    showMandatoryfield: "showMandatoryfield",
    cancelDraft: "cancelpdiDraft",
    modelList: "modelListpdi"
};
export var inspectionStatus = [{
        id: 1,
        name: "Pass"
    }, {
        id: 2,
        name: "Fail"
    }];
export var getSearchByList = [{
        id: "VinNo",
        name: "Vin No"
    }, {
        id: "EngineNo",
        name: "Engine No"
    }];
export var checkList = [{
        id: 1,
        label: "Mobile holder"
    }, {
        id: 2,
        label: "Saddle stay"
    }, {
        id: 3,
        label: "Seat cover"
    }, {
        id: 4,
        label: "Knuckle guard"
    }];
export var PDICheckMandatoryFields = {
    'GroupTechnicianId': 'GroupTechnicianId',
    'IssueDescription': 'IssueDescription',
    'InspectionResult': 'InspectionResult'
};
export var PDIMandatoryKeys = {
    InspectorDesignation: "InspectorDesignation",
    TechnicianDesignation: "TechnicianDesignation",
    IsDescriptiOnFailure: "IsDescriptiOnFailure",
    PDIChecksOnSameVehicle: "PDIChecksOnSameVehicle",
    IsTechnicianMarkedAsBusy: "IsTechnicianMarkedAsBusy",
    TechnicianColumnmandatoryOrOptional: "TechnicianColumnmandatoryOrOptional",
    TechnicianColumnAtLineLevel: "TechnicianColumnAtLineLevel"
};
export var getStatusBorderColor = function (status) {
    var borderColor;
    switch (status) {
        case 'Cancelled':
            borderColor = "#F5222D";
            break;
        case 'Open':
            borderColor = "#3697FF";
            break;
        case 'Complete':
            borderColor = "#52C41A";
            break;
        default:
            borderColor = "#DEE4EB";
            break;
    }
    return borderColor;
};
export var getTextbgColor = function (status) {
    var bgColor;
    switch (status) {
        case 'Cancelled':
            bgColor = "#FFF1F0";
            break;
        case 'Open':
            bgColor = "#F4F7FA";
            break;
        case 'Complete':
            bgColor = "#F6FFED";
            break;
        default:
            bgColor = "#F6FFED";
            break;
    }
    return bgColor;
};
export var getTextColor = function (status) {
    var textColor;
    switch (status) {
        case 'Cancelled':
            textColor = "#F5222D";
            break;
        case 'Open':
            textColor = "#3697FF";
            break;
        case 'Complete':
            textColor = "#52C41A";
            break;
        default:
            textColor = grey;
            break;
    }
    return textColor;
};
